import { render } from "./LandingComponent.vue?vue&type=template&id=36d3c854&scoped=true"
import script from "./LandingComponent.vue?vue&type=script&lang=js"
export * from "./LandingComponent.vue?vue&type=script&lang=js"

import "./LandingComponent.vue?vue&type=style&index=0&id=36d3c854&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d3c854"]])

export default __exports__